/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createCos } from '../../factoriesAny.js';
export var cosDependencies = {
  typedDependencies: typedDependencies,
  createCos: createCos
};